import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CustomDateFormatPipe],
  selector: 'app-policy-card-header',
  templateUrl: './policy-card-header.component.html',
  styleUrls: ['./policy-card-header.component.scss']
})
export class PolicyCardHeaderComponent implements OnInit {
  @Input() policy: any;
  isAcmic: boolean;

  constructor(private acmicService: AcmicService) { }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
  }

}
